import { useState } from "react";
import { isNative } from "../lib/native";

const PLAY_URL = "https://play.google.com/store/apps/details?id=com.hyuh.app";
// 지역 중립 링크 — 방문자 국가 App Store로 자동 이동(다국어 앱: /us/ 강제 안 함).
const APPSTORE_URL = "https://apps.apple.com/app/id6782901748";

// 실제 Google Play 로고(4색 재생 삼각형).
function GooglePlayIcon() {
  return (
    <svg className="store-ico" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path fill="#00C3FF" d="M3.064 2.066C2.694 2.27 2.46 2.66 2.46 3.2v17.6c0 .54.234.93.604 1.134l.09.05 9.86-9.86v-.232l-9.86-9.86z" />
      <path fill="#FFCE00" d="M16.21 15.39l-3.196-3.196v-.232l3.197-3.196.072.041 3.79 2.153c1.082.615 1.082 1.621 0 2.236l-3.79 2.153z" />
      <path fill="#FF3B30" d="M16.282 15.35l-3.268-3.268-9.95 9.95c.357.378.945.424 1.608.048l11.61-6.73" />
      <path fill="#00D856" d="M16.282 8.814L4.672 2.084c-.663-.376-1.251-.33-1.608.048l9.95 9.95 3.268-3.268z" />
    </svg>
  );
}

// 실제 Apple 로고(단색 — 펼침 메뉴 텍스트색 상속).
function AppleIcon() {
  return (
    <svg className="store-ico" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M16.365 1.43c0 1.14-.493 2.27-1.177 3.08-.744.9-1.99 1.57-2.987 1.57-.12 0-.23-.02-.3-.03-.01-.06-.04-.22-.04-.39 0-1.15.572-2.27 1.206-2.98.804-.94 2.142-1.64 3.248-1.68.03.13.05.28.05.43zm4.565 15.71c-.03.07-.463 1.58-1.518 3.12-.945 1.34-1.94 2.71-3.43 2.71-1.517 0-1.9-.88-3.63-.88-1.698 0-2.302.91-3.67.91-1.377 0-2.332-1.26-3.428-2.8-1.287-1.82-2.323-4.63-2.323-7.28 0-4.28 2.797-6.55 5.552-6.55 1.448 0 2.675.95 3.6.95.865 0 2.222-1.01 3.902-1.01.613 0 2.886.06 4.374 2.19-.13.09-2.383 1.37-2.383 4.19 0 3.26 2.854 4.42 2.955 4.45z" />
    </svg>
  );
}

// 웹 전용 — 모든 페이지에 고정되는 우측 플로팅 버튼. 탭하면 스토어 2개(안드로이드/iOS, 둘 다 출시) 펼침.
// 네이티브 앱·앱인토스에선 안 보임(자기가 앱) — isNative() 게이트.
export default function StoreFab() {
  const [open, setOpen] = useState(false);
  if (isNative()) return null;
  return (
    <div className={`store-fab ${open ? "open" : ""}`}>
      {open && (
        <div className="store-fab-menu">
          <a className="store-btn" href={PLAY_URL} target="_blank" rel="noreferrer">
            <GooglePlayIcon /> Google Play
          </a>
          <a className="store-btn" href={APPSTORE_URL} target="_blank" rel="noreferrer">
            <AppleIcon /> App Store
          </a>
        </div>
      )}
      <button className="store-fab-btn" onClick={() => setOpen((v) => !v)} aria-label="app download">
        {open ? "✕" : "⤓"}
      </button>
    </div>
  );
}
